<div class="grid place-items-center size-[130px] shrink-0 overflow-hidden">
  @if (imageSrc()) {
    <img
      [src]="imageSrc() | async"
      [alt]="imageName()"
      class="object-cover"
      data-testid="uploaded-image-preview"
    />
  } @else {
    <div
      [ngClass]="hasUploadedFiles() ? 'bg-neutral-100' : 'bg-neutral-700'"
      class="flex flex-col items-center justify-center gap-y-2 size-full rounded-lg"
    >
      <div
        [class.selected-file-preview-image]="hasUploadedFiles()"
        [innerHTML]="defaultImage()"
      ></div>
      @if (hasUploadedFiles()) {
        <span class="max-w-[114px] text-xs text-neutral-400 truncate whitespace-nowrap">{{
          fileName()
        }}</span>
      }
    </div>
  }
</div>

<div class="flex flex-col grow min-w-0 justify-center bg-black/10 p-6 rounded-lg gap-y-2">
  <div class="flex items-center min-w-0 justify-between gap-x-4">
    <div class="flex flex-col min-w-0 gap-y-1">
      <div class="text-sm font-semibold truncate">
        @if (hasUploadedFiles()) {
          {{ fileName() }}
        } @else {
          {{ config().noFileUploadedText || 'No file uploaded' }}
        }
      </div>
      <div class="text-xs text-neutral-500 truncate">
        @if (hasUploadedFiles()) {
          {{ fileType() }}&nbsp;&nbsp;•&nbsp;&nbsp;{{ fileSize() | flxFileSize }}
        } @else {
          Supported format: {{ supportedFormats()
          }}{{ maxFileSize() ? ', up to ' + (maxFileSize() | flxFileSize) : '' }}
        }
      </div>
    </div>

    <div class="flex items-center gap-x-4">
      @if (loading()) {
        <div class="flex items-center gap-x-2">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="9.00024"
              cy="9"
              r="8"
              transform="rotate(90 9.00024 9)"
              stroke="#8390A2"
              stroke-width="2"
            />
            <path
              id="fill-circle"
              d="M9.00171 1.00195C13.42 1.00195 17.0017 4.58368 17.0017 9.00195"
              stroke="#FEB913"
              stroke-width="2"
            />
          </svg>

          <span class="italic font-semibold opacity-50 text-sm">Uploading...</span>
        </div>

        <button
          (click)="cancelUpload()"
          class="flx-ds secondary whitespace-nowrap text-blue-500"
          flxButton
          type="button"
        >
          Cancel
        </button>
      } @else if (hasUploadedFiles()) {
        <button
          (click)="removeUploadedFiles()"
          class="flx-ds secondary whitespace-nowrap text-blue-500"
          flxButton
          type="button"
        >
          Remove
        </button>
      } @else {
        <button
          (click)="uploadInput.click()"
          class="flx-ds primary whitespace-nowrap"
          flxButton
          type="button"
        >
          <i class="ph ph-plus"></i>
          {{ config().uploadButtonText }}
        </button>

        <input
          #uploadInput
          [accept]="config().allowedFileTypes"
          [multiple]="config().isMultipleUploadAllowed"
          (change)="onFileSelected($event)"
          class="hidden"
          type="file"
        />
      }
    </div>
  </div>

  @if (error()) {
    <flx-message
      class="bg-red-500/20"
      type="error"
      display="fill"
    >
      <i
        class="ph ph-warning-circle text-red-500"
        flxMessageError
      ></i>
      {{ error() }}</flx-message
    >
  }
</div>
